var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E64B38",
    fill: "#FFFFFF",
    cx: 15,
    cy: 15,
    r: 14.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Delete-Icon-Reversed-Copy",
    transform: "translate(10.000000, 8.000000)",
    fill: "#E64B38",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73875,2.113125 L7.258125,2.113125 L7.258125,1.378125 C7.258125,1.010625 6.9825,0.735 6.615,0.735 L4.41,0.735 C4.0425,0.735 3.766875,1.010625 3.766875,1.378125 L3.766875,2.113125 L1.1025,2.113125 C0.91875,2.113125 0.735,2.296875 0.735,2.480625 C0.735,2.664375 0.91875,2.848125 1.1025,2.848125 L9.73875,2.848125 C9.9225,2.848125 10.10625,2.664375 10.10625,2.480625 C10.10625,2.296875 9.9225,2.113125 9.73875,2.113125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.010625,4.59375 L2.205,13.41375 C2.205,13.689375 2.480625,13.78125 2.664375,13.78125 L8.085,13.78125 C8.360625,13.78125 8.544375,13.5975 8.544375,13.41375 L9.73875,4.59375 C9.73875,4.318125 9.555,4.0425 9.279375,4.0425 L1.47,4.0425 C1.194375,4.0425 1.010625,4.318125 1.010625,4.59375 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDelete);
export default __webpack_public_path__ + "static/media/ListDelete.45c41f58fa48d6b9f5b1455206c10019.svg";
export { ForwardRef as ReactComponent };